import { SET_MARKETING_HAS_BROCHURE } from '../../types';

const initialState = {
    //  DESC: These are environment variables
    AppMarketingURL: process.env.APP_CLIENT === 'FDIC' ? 'http://fdic-ore.com' : 'http://www.usmsrealestate.com',
    hasBrochure: false
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_MARKETING_HAS_BROCHURE:
            return {
                ...state,
                hasBrochure: payload
            };
        default:
            return state;
    }
}
